export default __webpack_public_path__ + "static/media/timeup.e438c4f8.jpg";